import {
  type OpportunitiesSearchFilters,
  type OpportunitiesSearchOptions,
  type OpportunitySearch,
} from "@repo/api";

import { AssignProjectsModal } from "./modals/AssignProjectsModal";
import { ChangeStatusModal } from "./modals/ChangeStatusModal";
import { EditOpportunitiesModal } from "./modals/EditOpportunitiesModal";
import { type EditModalMode } from "./utils";

interface ProjectActionsProps {
  editModalMode: EditModalMode;
  setEditModalMode: React.Dispatch<React.SetStateAction<EditModalMode>>;
  selectedOpportunities: OpportunitySearch[];
  setSelectedOpportunities: React.Dispatch<
    React.SetStateAction<OpportunitySearch[]>
  >;
  filters: OpportunitiesSearchFilters;
  options: OpportunitiesSearchOptions;
}

export const ProjectActions = ({
  editModalMode,
  setEditModalMode,
  selectedOpportunities,
  setSelectedOpportunities,
  filters,
  options,
}: ProjectActionsProps) => (
  <>
    <ChangeStatusModal
      isOpen={editModalMode === "status"}
      setIsOpen={setEditModalMode}
      selectedOpportunities={selectedOpportunities}
      setSelectedOpportunities={setSelectedOpportunities}
      filters={filters}
      options={options}
    />
    <AssignProjectsModal
      isOpen={editModalMode === "assign"}
      setIsOpen={setEditModalMode}
      selectedOpportunities={selectedOpportunities}
      setSelectedOpportunities={setSelectedOpportunities}
      filters={filters}
      options={options}
    />
    <EditOpportunitiesModal
      isOpen={editModalMode === "cmp"}
      setIsOpen={setEditModalMode}
      selectedOpportunities={selectedOpportunities}
      setSelectedOpportunities={setSelectedOpportunities}
      filters={filters}
      options={options}
    />
  </>
);
